import React from 'react';
import '../css/Auspiciantes.css';


// Importación de imágenes
import pico from '../img/auspiciantes/Municipalidad de Pico.webp';
import alvear from '../img/auspiciantes/Municipalidad Alvear.webp';
import heguy from '../img/auspiciantes/Logo Heguy.webp';
import cascada from '../img/auspiciantes/la cascada agua .webp';
import hotel from '../img/auspiciantes/HOTEL PICO.webp';
import fedea from '../img/auspiciantes/FEDEA_newLogo-01.webp';
import rojas from '../img/auspiciantes/chacinadosrojas.webp';
import brupal from '../img/auspiciantes/brupal.webp';
import alarcia from '../img/auspiciantes/alarcia.webp';
import chilito from '../img/auspiciantes/chilito.webp';
import LoobStudio from '../img/auspiciantes/LoobStudio.webp';
import Citia from '../img/auspiciantes/citia.webp';
import ICOMEX from '../img/auspiciantes/ICOMEX.webp';
import Granos from '../img/auspiciantes/Granos del oeste.webp';
import pelayo from '../img/auspiciantes/pelayo.webp'
import NovaPizza from '../img/auspiciantes/Logo-2-Nova-Pizza_negro_.webp'
import ViegoGomez from '../img/auspiciantes/Logo-VG-_negro_.webp'
import YPF from '../img/auspiciantes/YPF.webp'
import MarianaHuerta from '../img/auspiciantes/Mariana Huerta.webp'
import MinisteriodelaProduccion from '../img/auspiciantes/Ministerio de la producción.webp'
import Cechetto from '../img/auspiciantes/Cechetto 1.webp'
import ComisionSpeluzzi from '../img/auspiciantes/Comision de Fomento Speluzzi.webp'
import Bosco from '../img/auspiciantes/Bosco.webp'
import Changus from '../img/auspiciantes/Changus.webp'
import Insubio from '../img/auspiciantes/Insubio.webp'
import laorquidia from '../img/auspiciantes/la orquidia.webp'
import aguaenvasada from '../img/auspiciantes/aguaenvasada.webp'
import DonFelipe from '../img/auspiciantes/DonFelipe.webp'
import Frutopampa from '../img/auspiciantes/Frutopampa.webp'
import metalmaq from '../img/auspiciantes/metalmaq.webp'
import Bodegasdeldesierto from '../img/auspiciantes/Bodegas del desierto.webp'
import Colegiodenutricionistas from '../img/auspiciantes/Colegio de Nutricionistas.webp'
import DulcePaloma from '../img/auspiciantes/Dulce paloma.webp'
import FrigorificoPico from '../img/auspiciantes/Frigorifico Pico.webp'
import fruggina from '../img/auspiciantes/fruggina.webp'
import JHAN from '../img/auspiciantes/JHAN.webp'
import LaTablita from '../img/auspiciantes/La tablita.webp'
import Dalmasso from '../img/auspiciantes/Logos - Dalmasso_page-0001.webp'
import PampaLab from '../img/auspiciantes/Pampa lab.webp'
import dumascat from '../img/auspiciantes/dumascat.webp'
import onelab from '../img/auspiciantes/onelab.webp'
import volante from '../img/auspiciantes/e salud volante-JPG-resumen.webp'
import imprenta from '../img/auspiciantes/imprenta.webp'
import chipaceria from '../img/auspiciantes/La chipaceria.webp'
import linea from '../img/auspiciantes/linea.webp'
import ohra from '../img/auspiciantes/ohra pampa.webp'
import santander from '../img/auspiciantes/Santander 2.webp'

function Sponsors() {
  return (
    <div className="auspiciantes" translate="no">
      <h1>Auspiciantes</h1>

      <div className="intro-sponsors">
        <h2><strong>Empresas e Instituciones que nos acompañan en el I COPAT-AL</strong></h2>
        <p>
          Agradecemos profundamente el respaldo de quienes hacen posible este evento. <strong>Sumate</strong> como auspiciante y sé parte de una iniciativa única que conecta la innovación, la ciencia y la industria alimentaria.
        </p>
      </div>

      <div className="sponsors-grid">
        <div className="logo-box"><img src={pico} alt="Municipalidad de Pico" /></div>
        <div className="logo-box"><img src={alvear} alt="Municipalidad de Alvear" /></div>
        <div className="logo-box"><img src={heguy} alt="Logo Heguy" /></div>
        <div className="logo-box"><img src={cascada} alt="La Cascada Agua" /></div>
        <div className="logo-box"><img src={hotel} alt="Hotel Pico" /></div>
        <div className="logo-box"><img src={fedea} alt="FEDEA" /></div>
        <div className="logo-box"><img src={rojas} alt="Chacinados Rojas" /></div>
        <div className="logo-box"><img src={brupal} alt="Brupal" /></div>
        <div className="logo-box"><img src={alarcia} alt="Alarcia" /></div>
        <div className="logo-box"><img src={chilito} alt="chilito" /></div>
        <div className="logo-box"><a href='https://loobstudio.netlify.app/' target='_BLANK'><img src={LoobStudio} alt="LoobStudio"/></a></div>
        <div className="logo-box"><img src={Citia} alt="Citia" /></div>
        <div className="logo-box"><img src={ICOMEX} alt="ICOMEX" /></div>
        <div className="logo-box"><img src={Granos} alt="Granos del oeste S.A." /></div>
        <div className="logo-box"><img src={pelayo} alt="Pelayo" /></div>
        <div className="logo-box"><img src={NovaPizza} alt="NovaPizza" /></div>
        <div className="logo-box"><img src={ViegoGomez} alt="ViegoGomez" /></div>
        <div className="logo-box"><img src={YPF} alt="YPF" /></div>
        <div className="logo-box"><img src={MarianaHuerta} alt="Mariana Huerta" /></div>
        <div className="logo-box"><img src={MinisteriodelaProduccion} alt="Ministerio de la producción" /></div>
        <div className="logo-box"><img src={Cechetto} alt="Cechetto" /></div>
        <div className="logo-box"><img src={ComisionSpeluzzi} alt="Comision de Fomento Speluzzi" /></div>
        <div className="logo-box"><img src={Bosco} alt="Bosco" /></div>
        <div className="logo-box"><img src={Changus} alt="Changus" /></div>
        <div className="logo-box"><img src={Insubio} alt="Insubio" /></div>
        <div className="logo-box"><img src={laorquidia} alt="la orquidia" /></div>
        <div className="logo-box"><img src={aguaenvasada} alt="aguaenvasada" /></div>
        <div className="logo-box"><img src={DonFelipe} alt="Don Felipe" /></div>
        <div className="logo-box"><img src={Frutopampa} alt="Frutopampa" /></div>
        <div className="logo-box"><img src={metalmaq} alt="metalmaq" /></div>
        <div className="logo-box"><img src={Bodegasdeldesierto} alt="Bodegas del desierto" /></div>
        <div className="logo-box"><img src={Colegiodenutricionistas} alt="Colegio de Nutricionistas" /></div>
        <div className="logo-box"><img src={DulcePaloma} alt="Dulce Paloma" /></div>
        <div className="logo-box"><img src={FrigorificoPico} alt="Frigorifico Pico" /></div>
        <div className="logo-box"><img src={fruggina} alt="fruggina" /></div>
        <div className="logo-box"><img src={JHAN} alt="JHAN" /></div>
        <div className="logo-box"><img src={LaTablita} alt="La Tablita" /></div>
        <div className="logo-box"><img src={Dalmasso} alt="Dalmasso" /></div>
        <div className="logo-box"><img src={PampaLab} alt="Pampa Lab" /></div>
        <div className="logo-box"><img src={dumascat} alt="dumascat" /></div>
        <div className="logo-box"><img src={onelab} alt="onelab" /></div>
        <div className="logo-box"><img src={volante} alt="volante" /></div>
        <div className="logo-box"><img src={santander} alt="santander" /></div>
        <div className="logo-box"><img src={imprenta} alt="imprenta" /></div>
        <div className="logo-box"><img src={chipaceria} alt="chipaceria" /></div>
        <div className="logo-box"><img src={linea} alt="linea" /></div>
        <div className="logo-box"><img src={ohra} alt="ohra" /></div>
      </div>

      <section className="condiciones-sponsor">
        <h2>Condiciones para ser sponsors en el I COPAT-AL</h2>
        <div className="separator"></div>

        <h3>¿Por qué ser sponsor en el I COPAT-AL?</h3>
        <p>
          Siendo sponsor en el <strong>I Congreso Patagónico de Alimentos 2025</strong> podés posicionar tu marca en el principal encuentro que reúne a la comunidad científico-académica, empresas, productores y emprendedores del sector agroalimentario.
        </p>
        <p>
          Es una forma de darte a conocer mostrando tus productos, servicios y tecnologías en un espacio pensado para crear vínculos estratégicos, generar oportunidades de negocio y potenciar la innovación.
        </p>
        <p>
          Esperamos contar con tu apoyo en este evento que impulsa la conexión entre el conocimiento, el desarrollo empresarial y la evolución de la industria alimentaria.
        </p>

        <h3>¿Cómo ser sponsors en el I COPAT-AL?</h3>

        <div className="opciones">
          <div className="opcion-card">
            <h4>OPCIÓN 1: STAND FÍSICO</h4>
            <p>
              Stand de 3m x 3m en la sede del Congreso para exhibir productos y/o servicios. Incluye presencia de logos en redes sociales, web y flyers.
            </p>
          </div>

          <div className="opcion-card">
            <h4>OPCIÓN 2: BANNER</h4>
            <p>
              Espacios específicos para banners o banderas. Incluye presencia de logos en redes sociales, web y flyers.
            </p>
          </div>

          <div className="opcion-card">
            <h4>OPCIÓN 3: LOGOS EMPRESARIALES</h4>
            <p>
              Presencia de los logos como auspiciantes en redes sociales, web y flyers durante el evento.
            </p>
          </div>

          <div className="opcion-card">
            <h4>OPCIÓN 4: SPONSOR ESPECIAL</h4>
            <p>
              Presencia de logos y posibilidad de realizar aportes específicos y confidenciales para necesidades del proyecto (equipamiento, transporte, becas, etc.).
            </p>
          </div>
        </div>

        <p className="link-sponsor">
          <strong>👉 Link para participar como sponsor:</strong><br />
          <a href="https://forms.gle/YkSwquKg9zCkwQ6ZA" target="_blank" rel="noreferrer">
            Completar formulario de inscripción
          </a>
        </p>
      </section>
    </div>
  );
}

export default Sponsors;
